import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const GradFairRegisterModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "GradFairRegisterModalContainer" */
      './GradFairRegisterModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
